import React, { useCallback, useEffect, useState } from 'react'
import { Col, Row, Card, Table, Form, Button } from '@themesberg/react-bootstrap'
import { useCookies } from 'react-cookie'
import {
  getAllTicketEmployees,
  addTicketEmployee,
  updateTicketEmployee,
  updateTicketEmployeeStatus,
  resetTicketEmployeePassword,
} from '../../../../controller/api/ticketEmployee'
import TicketEmployeeFormModal from '../sub-screen/TicketEmployeeFormModal'
import TicketEmployeeResetPasswordModal from '../sub-screen/TicketEmployeeResetPasswordModal'

const TableRow = ({ row, onEdit, onResetPassword, onStatusChange }) => (
  <tr>
    <td>{row.username}</td>
    <td>{row.name || '—'}</td>
    <td>{row.phone || '—'}</td>
    <td style={{ width: 180 }}>
      <Form.Select value={row.status} onChange={(evt) => onStatusChange(evt, row.id)}>
        <option value={0}>Inactive</option>
        <option value={1}>Active</option>
      </Form.Select>
    </td>
    <td>
      <Button variant="outline-primary" size="sm" className="m-1" onClick={() => onEdit(row)}>
        Sửa
      </Button>
      <Button variant="outline-secondary" size="sm" className="m-1" onClick={() => onResetPassword(row)}>
        Đổi MK
      </Button>
    </td>
  </tr>
)

export const TicketEmployeeTable = () => {
  const [cookies] = useCookies(['lottmekong'])
  const [list, setList] = useState([])
  const [formModal, setFormModal] = useState({ show: false, mode: 'add', employee: null })
  const [resetModal, setResetModal] = useState({ show: false, employee: null })

  const loadEmployees = useCallback(async () => {
    const response = await getAllTicketEmployees(cookies.lottmekong)
    if (response.error) {
      alert(response.message || 'Không tải được danh sách')
      return
    }
    setList(response.data || [])
  }, [cookies.lottmekong])

  useEffect(() => {
    loadEmployees()
  }, [loadEmployees])

  const onStatusChange = async (evt, id) => {
    const status = parseInt(evt.target.value, 10)
    if (status === 0 && !window.confirm('Vô hiệu hóa tài khoản này? Nhân viên sẽ bị đăng xuất.')) {
      loadEmployees()
      return
    }
    const resp = await updateTicketEmployeeStatus(cookies.lottmekong, id, status)
    if (resp?.error) {
      alert(resp.message || 'Có lỗi xảy ra')
    }
    loadEmployees()
  }

  const handleFormSubmit = async (payload) => {
    if (formModal.mode === 'add') {
      return addTicketEmployee(cookies.lottmekong, payload)
    }
    return updateTicketEmployee(cookies.lottmekong, payload)
  }

  const handleFormHide = (reload) => {
    setFormModal({ show: false, mode: 'add', employee: null })
    if (reload) loadEmployees()
  }

  const handleResetSubmit = async (id, password) => {
    return resetTicketEmployeePassword(cookies.lottmekong, id, password)
  }

  const handleResetHide = (reload) => {
    setResetModal({ show: false, employee: null })
    if (reload) loadEmployees()
  }

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col>
              <h5>Nhân viên in vé ({list.length})</h5>
            </Col>
            <Col className="text-end">
              <Button
                variant="success"
                onClick={() => setFormModal({ show: true, mode: 'add', employee: null })}
              >
                Thêm nhân viên
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Table responsive className="align-items-center table-flush">
          <thead className="thead-light">
            <tr>
              <th>Tên đăng nhập</th>
              <th>Tên hiển thị</th>
              <th>Số điện thoại</th>
              <th>Trạng thái</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {list.map((row) => (
              <TableRow
                key={row.id}
                row={row}
                onEdit={(employee) => setFormModal({ show: true, mode: 'edit', employee })}
                onResetPassword={(employee) => setResetModal({ show: true, employee })}
                onStatusChange={onStatusChange}
              />
            ))}
          </tbody>
        </Table>
      </Card>

      <TicketEmployeeFormModal
        show={formModal.show}
        mode={formModal.mode}
        employee={formModal.employee}
        onHide={handleFormHide}
        onSubmit={handleFormSubmit}
      />

      <TicketEmployeeResetPasswordModal
        show={resetModal.show}
        employee={resetModal.employee}
        onHide={handleResetHide}
        onSubmit={handleResetSubmit}
      />
    </>
  )
}
